import { M1CampaignPage } from "./M1CampaignPage";

const M1Campaign = () => {
	return <M1CampaignPage />;
};
export default M1Campaign;
